/*
 * @Author: your name
 * @Date: 2020-12-16 16:45:02
 * @LastEditTime: 2021-10-28 15:02:58
 * @LastEditors: DG
 * @Description: In User Settings Edit
 * @FilePath     : /fe-ts-basic-platform/src/utils/const.js
 */
import moment from 'moment';

export const STATION = 'op_station_id';

export const STATION_DATA_SOURCE_FROM = {
  DATA: {
    201: 'ElogOMS系统同步',
    202: 'NOMS系统同步',
  },
  DEFINE: {
    手动添加: 1,
  },
};

export const COMMON_DATA_SOURCE_FROM = {
  DATA: {
    101: 'FluxWMS系统同步',
    102: '50WMS',
    103: 'NWMS系统同步',
    104: '物资NWMS系统同步',
    105: 'SkaWMS系统同步',
    201: 'ElogOMS系统同步',
    202: 'NOMS系统同步',
    301: '薪职场',
    302: '丰考勤',
  },
};

// 盘点类型
export const AREA = {
  DATA: {
    10000001: '中国大陆',
    20000001: '中国香港',
  },
};

// 页面的基础数据，如果以后有统一修改，方便操作
export const DEFAULT = {
  PAGINATION: {
    page_no: 1,
    page_size: 50,
  },
  ALL: '-1',
};

export const DEFAULTJAVA = {
  PAGINATION: {
    page: 1,
    pageSize: 50,
  },
  ALL: '-1',
};

export const PAYROLL_METHOD = {
  DATA: {
    1: '计时',
    2: '计件',
  },
  DEFINE: {
    hours: '1',
    unit: '2',
  },
};

//  0待审批 1未生效 2已驳回 3已生效 4已作废 5已失效
export const PAYROLL_CONF_STATUS = {
  DATA: {
    0: '待审批',
    1: '未生效',
    2: '已驳回',
    3: '已生效',
    4: '已作废',
    5: '已失效',
  },
  DEFINE: {},
};

// 1出库，2入库，3库内，4其它
export const TASK_TYPE = {
  DATA: {
    1: '出库',
    2: '入库',
    3: '库内',
    4: '其他',
  },
  DEFINE: {
    OUT_STOCK: '1',
  },
};

//  1 手动添加 2 系统同步
export const DATA_SOURCE = {
  DATA: {
    1: '手动添加',
    2: '系统同步',
  },
  DEFINE: {
    MANUAL_CONTROL: 1,
  },
};

//  1 手动添加 2 系统同步
export const DATA_SOURCE_INSIDE = {
  DATA: {
    1: '手动添加',
    2: '系统默认',
  },
  DEFINE: {
    MANUAL_CONTROL: 1,
  },
};
// 1手动添加   2系统同步
export const DATA_SOURCE_FROM = {
  DATA: {
    1: '手动添加',
    2: '系统同步',
  },
};

export const STATUS = {
  DATA: {
    1: '启用',
    0: '禁用',
  },
  DEFINE: {
    ENABLE: '1',
    DISABLE: '0',
  },
  OPERATE: {
    0: '1',
    1: '0',
  },
};

export const TRUE_OR_FALSE = {
  DATA: {
    0: '不启用',
    1: '启用',
  },
  DEFINE: {
    false: '0',
    true: '1',
  },
};

export const LOG_COLUMN = () => {
  return [
    {
      title: '操作时间',
      dataIndex: 'time',
      width: 160,
      // render: (_, row) =>
      //   row.time && moment(new Date(row.time) * 1000).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '操作内容',
      dataIndex: 'record',
    },
    {
      title: '操作人',
      dataIndex: 'operator',
      width: 80,
    },
  ];
};

export const LOG_COLUMN_FIELDS = () => [
  {
    title: '操作时间',
    dataIndex: 'createTime',
    width: 160,
    render: (_, row) =>
      row.createTime && moment(row.createTime * 1000).format('YYYY-MM-DD HH:mm:ss'),
  },
  {
    title: '操作内容',
    dataIndex: 'content',
  },
  {
    title: '操作人',
    dataIndex: 'accountName',
    width: 80,
  },
];

export const PIECE_GROUP_TYPE = {
  1: '临时编组',
  2: '长期编组',
};

export const PIECE_GROUP_STATUS = {
  1: '生效中',
  2: '已解散',
};

export const SOURCE = {
  1: '手动添加',
  2: '系统同步',
};

export const BUSINESS_LINE = {
  1: 'TS条线',
  2: '物资条线',
  3: '双捷条线',
  '-1': '全部',
};

export const IS_DEL = {
  0: '启用',
  1: '禁用',
};

export const DIM_TYPE = {
  1: '任务行',
  2: '票',
  3: '波次',
};

export const PARAM_TYPE = {
  1: '数值型',
  2: '枚举型',
  3: '文本型',
};

export const PICK_TYPE = {
  1: '整拣',
  2: '散拣',
};

export const PICK_TYPE_ID = {
  整拣: 1,
  散拣: 2,
};

export const IS_MODIFY_BILL_TIME = {
  0: '不修改',
  1: '修改',
};

// 是否团队计件
export const IS_TEAM_WORK = {
  0: '否',
  1: '是',
};

// 人员计薪配置状态
export const STAFF_SALARY_STATUS = {
  DATA: {
    0: '未配置',
    1: '已配置',
  },
  DEFINE: {
    NOT_CONFIGURED: 0,
    CONFIGURED: 1,
  },
};

// 人员计薪配置员工类型
export const STAFF_SALARY_EMPTYPE = {
  DATA: {
    1: '个人计件岗',
    2: '限定工时岗',
    3: '团队计件岗',
  },
  DEFINE: {
    MASTER_PIECEWORK: 1,
    NON_MASTER_PIECEWORK: 2,
    TEAM_JOB: 3,
  },
};

// 人员计薪配置员工类型
export const STAFF_SALARY_IS_LEADER = {
  DATA: {
    0: '否',
    1: '是',
  },
  DEFINE: {
    YES: 1,
    NO: 0,
  },
};

/** 员工类型枚举 */
export const STAFF_SALARY_EMP_TYPE_SYNC = {
  DATA: {
    0: '外包',
    1: '自有',
  },
  DEFINE: {
    EXTERNAL: 0,
    INTERnal: 1,
  },
};

// 汇率状态
export const RATE_STATUS = {
  DATA: {
    0: '禁用',
    1: '生效中',
    2: '已失效',
    3: '未生效',
  },
  DEFINE: {
    DISABLED: 0,
    IN_EFFECT: 1,
    INVALID: 2,
    NOT_EFFECTIVE: 3,
  },
};

// 接口返回的下拉筛选项默认值
export const defaultOptionAll = {
  arrayType: [
    {
      label: '全部',
      value: '-1',
    },
  ],
};

// 薪资计算-计薪模式
export const SALARY_CALC_MODE = {
  DATA: {
    1: '工时模式',
    2: '单价模式',
  },
  DEFINE: {
    MAN_HOUR_MODE: 1,
    UNIT_HOUR_MODE: 2,
  },
};

// 薪资计算-打卡匹配
export const SALARY_PUNCH_MATCH = {
  DATA: {
    1: '需匹配打卡',
    2: '不匹配打卡',
  },
  DEFINE: {
    MATCH: 1,
    NOTMATCH: 2,
  },
};

// 计件编组-编组单据时间
export const PIECEGROUP_BILL_TIME = {
  DATA: {
    0: '不修改',
    1: '修改',
  },
};

// 薪资日报-是否计算
export const SALARY_REPORT_CALC = {
  DATA: {
    0: '不计算',
    1: '计算',
  },
};

// 薪资计算-计件薪资计算方式
export const PIECE_SALARY_CALC_MODE = {
  DATA: {
    1: '标准产出工时',
    2: '计薪方案工时',
  },
  DEFINE: {
    STANDARD_HOUR: 1,
    SALARY_HOUR: 2,
  },
};

// 作业单据-是否生成包装单据
export const JOB_RECEIPT_BAOZHUANG_ENUM = {
  DATA: {
    0: '不生成',
    1: '生成',
  },
};

export const INFINITY = {
  DATA: '无穷大',
  DEFINE: 99999999,
};
